/**
 * Nombre de archivo para descargar un adjunto.
 *
 * El backend (AdjuntosService.getNombre) devuelve etiquetas de presentación
 * sin extensión ("Orden Medica", "Documento extra enviado por el usuario...")
 * y file-saver no la agrega: guarda el nombre tal cual con `a.download = name`.
 * La extensión real vive en el nombre almacenado del adjunto
 * (p. ej. "abc.ORM.xyz.user.pdf"), que el front sí tiene al descargar.
 *
 * Se alinea con lo que ya hace el envío por email (solicitud-notify.service).
 */
export function nombreConExtension(nombre: string, adjunto: string): string {
    const base = (nombre || 'Documento').trim();
    // lastIndexOf: los aprobados se guardan como "abc.ORM.xyz.user.pdf",
    // así que la última aparición del punto es la extensión correcta.
    const punto = adjunto ? adjunto.lastIndexOf('.') : -1;
    const ext = punto !== -1 ? adjunto.slice(punto) : '';

    if (!ext) {
        return base;
    }

    return base.toLowerCase().endsWith(ext.toLowerCase())
        ? base
        : `${base}${ext}`;
}
